import React, { useRef, useEffect, useState, forwardedRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';

const SubHeader = (props) => {

  const navigate = useNavigate();
  const location = useLocation();
  const [isTopBtnOn, setIsTopBtnOn] = useState(false)
  const topBtn = useRef()


  const observer = useRef(
    new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            setIsTopBtnOn(true)
          } else {
            setIsTopBtnOn(false)
          }
        });
      },
      { threshold: 0.01 }
    )
  );

  useEffect(() => {
    const subkv = document.querySelector('#SUBKV');
    subkv && observer.current.observe(subkv);

    return () => {
      const subkv = document.querySelector('#SUBKV');
      subkv && observer.current.unobserve(subkv);
    }
  }, []);



  // back_btn 클릭 핸들러
  const handleBackButtonClick = () => {
    // 최상위 루트로 이동
    navigate('/');
    
    // 페이지의 고유값을 가져와서 해당 위치로 이동
    // const pageCheck = localStorage.getItem('pageCheck');
    // localStorage.setItem("moveSectionNum", pageCheck);
  };


  return (
    <>
      <header id="SUBHEADER" className={`${isTopBtnOn ? "on" : ""}`}>
        <button className="back_btn" onClick={handleBackButtonClick}>
        </button>
        <button onClick={() => props.content?.scrollTo({ top: 0, behavior: 'smooth' })} ref={topBtn}
          className={`top_btn ${props.class}`}
        >
          <picture>
            <img src={props.title.pcSrc} alt={props.title.alt} />
          </picture>
        </button>
      </header>
    </>
  );
}

export default SubHeader;